import { createSelector } from 'reselect'

export const getAdmin = (state) => state.get('engagement').admin || {}

export const getOrganization = (state) => state.get('engagement').orgs || {}

export const getAdminAdmins = createSelector([getAdmin], (data) => data.get('admins'))

export const getAdminCount = createSelector([getAdmin], (data) => data.get('count'))

export const getAdminMe = createSelector([getAdmin], (data) => data.get('me'))

export const getRoles = createSelector([getAdmin], (data) => data.get('roles'))

export const getCompany = createSelector([getOrganization], (data) => data.get('company'))

export const adminsLoading = createSelector([getAdmin], (data) => data.get('loadingAdmins'))
